import { Session } from '../../utils/session'

const apiVersion = 'v1'

const session = new Session()

export const BASE_PATH = `api/${apiVersion}/clients/${session.getClientSession()}/settings`
